export const DATE_FORMATS = {
  parse: {
    dateInput: 'MMM D',
  },
  display: {
    dateInput: 'MMM D',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
